import { TerminalContract } from '../../services/openapi';

// extend contract for draft usage
export type TerminalContractDraftData = TerminalContract & {
    __draftKey?: string;
};

export type DraftTerminalContract = {
    key: string;
    mode: 'existing' | 'new';
    original: TerminalContractDraftData | null;
    current: TerminalContractDraftData;
};

export function createExistingDraft(contract: TerminalContract): DraftTerminalContract {
    const key = contract.id.toString();
    return {
        key,
        mode: 'existing',
        original: { ...contract, __draftKey: key },
        current: { ...contract, __draftKey: key }
    };
}

export function createNewDraft(
    terminalId: number,
    poi?: string,
    terminalDescription?: string
): DraftTerminalContract {
    const key = `new:${Date.now()}`;

    return {
        key,
        mode: 'new',
        original: null,
        current: {
            id: 0,
            terminalId,
            poi,
            terminalDescription,
            brand: '',
            host: '',
            isActive: 'True',
            tid: '',
            mid: '',
            propertyNames: {},
            __draftKey: key
        }
    };
}

export function hasContractChanged(draft: DraftTerminalContract): boolean {
    if (draft.original === null) {
        return true;
    }

    return (
        (draft.original.brand ?? '') !== (draft.current.brand ?? '') ||
        (draft.original.host ?? '') !== (draft.current.host ?? '') ||
        (draft.original.isActive ?? '') !== (draft.current.isActive ?? '') ||
        (draft.original.tid ?? '') !== (draft.current.tid ?? '') ||
        (draft.original.mid ?? '') !== (draft.current.mid ?? '')
    );
}